import { default as Modal } from 'antd/es/modal';
import type { Dispatch } from 'react';
import { useCallback } from 'react';

import { useDeleteDisbursementPayoutDraftsId } from 'api';

import { useCurrentOrganisation } from 'hooks/context';

import { TertiaryButton } from '@atoms/buttons/TertiaryButton';

type Props = {
  draftId: number;
  onCancel: Dispatch<void>;
};

export const CancelPayoutDraftButton = ({ draftId, onCancel }: Props) => {
  const org = useCurrentOrganisation();

  const { mutate: deleteDraft } = useDeleteDisbursementPayoutDraftsId({
    mutation: {
      onSuccess: () => {},
      onError: (_) => {}
    }
  });

  const cancelPayoutDraft = useCallback(() => {
    if (org.id) {
      deleteDraft({
        organisationId: org.id,
        id: draftId
      });
    }
    onCancel();
  }, [deleteDraft, draftId, org, onCancel]);

  const handleOnCancel = useCallback(() => {
    Modal.confirm({
      title: 'Cancel unfinished manual payout request',
      content: 'Are you sure? It will be deleted.',
      okText: 'Yes',
      cancelText: 'No',
      onOk: cancelPayoutDraft
    });
  }, [cancelPayoutDraft]);

  return (
    <TertiaryButton
      className="border border-content-positive-strong"
      onClick={handleOnCancel}
    >
      Cancel request
    </TertiaryButton>
  );
};
